import type { FormQuestion } from '../data/questions';

export type Answer = 'a' | 'b' | 'c';

export type ShuffledQuestion = FormQuestion & {
  originalLetter: Record<Answer, Answer>;
};

export function shuffle<T>(arr: T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = out[i] as T;
    out[i] = out[j] as T;
    out[j] = tmp;
  }
  return out;
}

export function shuffleOptions(q: FormQuestion): ShuffledQuestion {
  const order = shuffle<Answer>(['a', 'b', 'c']);
  return {
    ...q,
    options: {
      a: q.options[order[0]!],
      b: q.options[order[1]!],
      c: q.options[order[2]!],
    },
    originalLetter: { a: order[0]!, b: order[1]!, c: order[2]! },
  };
}
